module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"valid_message_length":"(有効文字数: {0}文字)"}}')
  delete Component.options._Ctor
}
